import { defineStore } from 'pinia'
export const useLayoutStore = defineStore('layout', {
  state: () => ({
    showSidenav: true as boolean,
    showNavbar: true as boolean,
    sideNavPined: true as boolean
  }),
  actions: {
    toggleEveryDisplay() {
      this.showSidenav = !this.showSidenav
      this.showNavbar = !this.showNavbar
    },
    hideEveryDisplay() {
      this.showSidenav = false
      this.showNavbar = false
    },
    showEveryDisplay() {
      this.showSidenav = true
      this.showNavbar = true
    },
    toggleSideNav() {
      const sidenavShow = document.getElementsByClassName('notefie-dashboard-panel')[0]
      if (sidenavShow) {
        if (sidenavShow.classList.contains('notefie-dashboard-panel-pinned')) {
          sidenavShow.classList.remove('notefie-dashboard-panel-pinned')
          sidenavShow.classList.add('notefie-dashboard-panel-hidden')
          this.sideNavPined = true
        } else {
          sidenavShow.classList.remove('notefie-dashboard-panel-hidden')
          sidenavShow.classList.add('notefie-dashboard-panel-pinned')
          this.sideNavPined = false
        }
      }
    },
    showSideNav() {
      const sidenavShow = document.getElementsByClassName('notefie-dashboard-panel')[0]
      if (sidenavShow) {
        if (!sidenavShow.classList.contains('notefie-dashboard-panel-pinned')) {
          sidenavShow.classList.remove('notefie-dashboard-panel-hidden')
          sidenavShow.classList.add('notefie-dashboard-panel-pinned')
        }
      }
    },
    hideSideNav() {
      const sidenavShow = document.getElementsByClassName('notefie-dashboard-panel')[0]
      if (sidenavShow) {
        if (sidenavShow.classList.contains('notefie-dashboard-panel-pinned')) {
          sidenavShow.classList.remove('notefie-dashboard-panel-pinned')
          sidenavShow.classList.add('notefie-dashboard-panel-hidden')
        }
      }
    }
  },
  persist: false
})
